import { useEffect, useRef } from "react";
import usePages from "../../Hooks/Display/usePages";
import { getEntityPages, updatePage } from "../../API/Display/Display";
import * as pagesEvents from "../../Context/Display/Pages/PagesContextEvents";
import TreeView from "./Pages/TreeView";
import NewPageDialog from "./Pages/NewPageDialog";
import { usePropsStoreState } from "../../Hooks/PropStore/usePropsStore";
import ContextMenu from "./Pages/ContextMenu";
import EditPageDialog from "./Pages/EditPageDialog";
import DeletePageDialog from "./Pages/DeletePageDialog";
import { TreeViewDragAnalyzer, TreeViewDragClue, moveTreeViewItem } from "@progress/kendo-react-treeview";
import { getClassOfDragEvent, getOrderOfReorderedPages, isDroppedInOtherFolder } from "./Pages/drag-drop";
import Scrollable from "../Shared/Edit/Scrollable";
import { getPortals } from "../../API/Portal/Portal";

function Pages() {

    const { projectId, entityId } = usePropsStoreState();

    const [state, dispatch] = usePages();

    const dragClue = useRef(null);

    useEffect(() => {
        getData()
            .then(data => {
                dispatch({
                    type: pagesEvents.SET_PAGES,
                    payload: data
                })
            })
            .catch(error => {
                debugger;
            })
    }, [])

    async function getData() {
        const portals = await getPortals(projectId);
        const pages = await getEntityPages(entityId);
        const data = [];
        debugger;
        for (const portal of portals) {
            const portalData = {
                id: portal._id,
                folderName: portal.portalName,
                type: "folder",
                expanded: true,
                pages: pages.data.filter(page => page.portalId === portal._id)
            }
            data.push(portalData);
        }
        return data
    }

    function selectPage(event) {
        if (event.item.type !== "folder") {
            dispatch({
                type: pagesEvents.SELECT_PAGE,
                payload: event.item.treeIndex
            })
        }
    }

    function toggleAddNewPageDialog() {
        dispatch({
            type: pagesEvents.TOGGLE_ADD_NEW_PAGE_DIALOG
        })
    }

    function toggleContextMenu(event, item) {
        if (event.type === "contextmenu") {
            event.preventDefault();
            dispatch({
                type: pagesEvents.TOGGLE_CONTEXT_MENU,
                payload: { 
                    offset: { left: event.clientX, top: event.clientY },
                    index: item.treeIndex
                }
            })
        }
    }

    function handleDragOver(event) {
        const icon = getClassOfDragEvent(event, state.pages);
        dragClue.children.show(
            event.pageY - 180,
            event.pageX - 240,
            event.item.text,
            icon
        )
    }

    function handleDragEnd(event) {
        dragClue.children.hide();
        const eventAnalyzer = new TreeViewDragAnalyzer(event).init();
        const droppedInOtherFolder = eventAnalyzer.isDropAllowed && isDroppedInOtherFolder(
            eventAnalyzer.itemId, eventAnalyzer.destItemId
        )
        if (
            eventAnalyzer.isDropAllowed &&
            eventAnalyzer.getDropOperation() !== "child" && !droppedInOtherFolder
        )  {
            const details = getOrderOfReorderedPages(event, state.pages);
            updatePage(details.target._id, { order: details.targetOrder });
            updatePage(details.dragged._id, { order: details.draggedOrder });
            const reorderedTree = moveTreeViewItem(
                event.itemHierarchicalIndex,
                state.pages,
                eventAnalyzer.getDropOperation(),
                eventAnalyzer.destinationMeta.itemHierarchicalIndex
            );
            dispatch({
                type: pagesEvents.REORDER_PAGE,
                payload: reorderedTree
            })
        }
    }

    return (
        <div className="h-100">
            <div className="d-flex justify-content-between align-items-center m-0 p-2">
                <h5>Pages</h5>
                <button className="btn btn-primary cursor-pointer" onClick={toggleAddNewPageDialog}>
                    <i className="fa-solid fa-plus" /> New Page
                </button>
            </div>
            {
                state.showAddNewPageDialog &&
                <NewPageDialog />
            }
            {
                state.showEditPageDialog &&
                <EditPageDialog />
            }
            {
                state.showDeletePageDialog &&
                <DeletePageDialog />
            }
            <hr className="m-0" />
            <ContextMenu />
            {
                state.pages && state.pages.length > 0 &&
                <div className="h-93">
                    <Scrollable>
                        <TreeView
                            className="pages-tree h-100"
                            expandField="expanded"
                            expandIcons={true}
                            draggable={true}
                            data={state.pages}
                            onItemClick={selectPage}
                            onContextMenu={toggleContextMenu}
                            onItemDragOver={handleDragOver}
                            onItemDragEnd={handleDragEnd}
                        />
                        <TreeViewDragClue ref={clue => {
                            dragClue.children = clue
                        }} />
                    </Scrollable>
                </div>
            }
        </div>
    )
}

export default Pages;